import { collection, query, where } from 'firebase/firestore'

import { COLLECTIONS } from '__constants__'
import { firestore } from 'services/firebase'
import { useCollectionData } from 'react-firebase-hooks/firestore'
import { useNewspaperConfig } from 'contexts/NewspaperConfig'

/**
 * It returns an array of values that are used to render the rewards
 * @param props - An object that contains the query parameters.
 * @returns An array of values.
 */
const useGetRewards = (props) => {
  const { newspaperId } = useNewspaperConfig()

  const [data, loading, error] = useCollectionData(
    newspaperId &&
      query(
        collection(firestore, COLLECTIONS.REWARDS),
        where('newspaperId', '==', newspaperId),
        where('status', '==', 'Active')
      )
  )

  return [data, loading, error]
}

export default useGetRewards
